var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 8.333 4.334 H 3.666 l 5.507 7.343 l -5.207 5.99 h 1.767 l 4.259 -4.899 l 3.674 4.9 h 4.667 l -5.74 -7.652 l 4.94 -5.682 h -1.767 l -3.99 4.59 l -3.443 -4.59 Z m 6 12 l -8 -10.667 h 1.333 l 8 10.667 h -1.333 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterx);
export default __webpack_public_path__ + "static/media/twitterx.b9b7a0a33da10ff61ca77b79c2e288e0.svg";
export { ForwardRef as ReactComponent };